import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-type" }

import { computed, inject } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'user-type',
  props: {
  modelValue: {
    type: String
  }
},
  emits: ['update:modelValue', 'userTypeChange'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

const radio = computed(() => {
  emits('userTypeChange', props.modelValue)
  return props.modelValue
})

const userPartChange: any = inject('userPartChange')
const radioChange = (val: string) => {
  console.log('radioChange', val)
  emits('update:modelValue', val)
  emits('userTypeChange', val)
  userPartChange(val)
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_radio_group, {
      modelValue: radio.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((radio).value = $event)),
      onChange: radioChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_radio, { label: '1' }, {
          default: _withCtx(() => [
            _createTextVNode("用户")
          ]),
          _: 1
        }),
        _createVNode(_component_el_radio, { label: '2' }, {
          default: _withCtx(() => [
            _createTextVNode("部门")
          ]),
          _: 1
        }),
        _createVNode(_component_el_radio, { label: '3' }, {
          default: _withCtx(() => [
            _createTextVNode("岗位")
          ]),
          _: 1
        }),
        _createVNode(_component_el_radio, { label: '4' }, {
          default: _withCtx(() => [
            _createTextVNode("角色")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})